<lex-doc-viewer-coding-section panelId="responsiveness-privilege-confidentiality" *inRole="[roles.StandardFeatureSet, roles.DocReviewFeatureSet]">
  <div coding-section-title>Responsiveness, Privilege, and Confidentiality</div>
  <div style="display: flex; flex-direction: column; gap: 18px;" [formGroup]="docViewerStore.documentCodingFormGroup">
    <div style="display: flex; flex-direction: column; margin-left:-1px">
      <mat-radio-group style="display: flex; gap: 3px; flex-direction: column; margin-left:-1px" formControlName="responsive">
        <mat-radio-button [value]="docCodingResponsiveness.NotSpecified">Not Specified</mat-radio-button>
        <mat-radio-button [value]="docCodingResponsiveness.Responsive">Responsive</mat-radio-button>
        <mat-radio-button [value]="docCodingResponsiveness.NonResponsive">Non-Responsive</mat-radio-button>
        <mat-radio-button [value]="docCodingResponsiveness.NeedsFurtherReview">Needs Further Review</mat-radio-button>
      </mat-radio-group>
    </div>
    <div>
      <lex-checkbox label="Key Document" [formControl]="docViewerStore.documentCodingFormGroup.get('isKey')"></lex-checkbox>
    </div>
    <div style="display: flex; flex-direction: column; gap: 3px;">
      <div style="display: flex; flex-direction: column; gap: 6px;">
        <lex-checkbox label="Confidential" [formControl]="docViewerStore.documentCodingFormGroup.get('confidential')"></lex-checkbox>
        <lex-checkbox label="Custom Designation" [formControl]="docViewerStore.documentCodingFormGroup.get('customDesignation')"></lex-checkbox>
      </div>
    </div>
    <div style="display: flex; flex-direction: column;">
      <div style="display: flex; flex-direction: column; gap: 6px;">
        <lex-checkbox label="Attorney-Client Privilege" [formControl]="docViewerStore.documentCodingFormGroup.get('privilege')"></lex-checkbox>
        <lex-checkbox label="Attorney Work Product" [formControl]="docViewerStore.documentCodingFormGroup.get('workProduct')"></lex-checkbox>
      </div>
      <div style="display: flex; flex-direction: row;  gap: 6px; margin: 4px 0 6px 0; align-items: flex-end;">
        <lex-checkbox label="Privileged: Needs Redaction" [disabled]="disableRedactForPrivilege()" [formControl]="docViewerStore.documentCodingFormGroup.get('redactForPrivilege')" >Privileged: Needs Redaction</lex-checkbox>
        <div style="font-size: 18px" matTooltip="This document is partially privileged. Its redacted version will be produced. See help to learn more.">
          <i class="fa-duotone fa-circle-info info-icon" ></i>
        </div>
      </div>

        <div class="mat-error" style="font-size:10px; padding-left:25px; align-items: normal;" *ngIf="docViewerStore?.documentCodingFormGroup?.errors?.redactForPrivilegeInvalid">
            Privileged: Needs Redaction cannot be checked without Attorney-Client Privilege and/or Attorney Work Product
        </div>

      <div style="display: flex; flex-direction: row; gap: 6px;">
        <lex-checkbox label="Personal Information: Needs Redaction" [formControl]="docViewerStore.documentCodingFormGroup.get('redactForPi')">Personal Information: Needs Redaction</lex-checkbox>
        <div style="font-size: 18px" matTooltip="This document contains Personal Information. Its redacted version will be produced. See help to learn more.">
          <i class="fa-duotone fa-circle-info info-icon" ></i>
        </div>
      </div>
      <lex-text-input [type]="'textarea'" label="Attorney Comments" style="margin-top: 10px;"
                      [formControl]="docViewerStore.documentReviewFormGroup.get('attorneyComments')" rows="1" maxlength="2000" pattern="[^<>]*"></lex-text-input>
      <div style="margin: 5px;"></div>
    </div>
  </div>
</lex-doc-viewer-coding-section>
